import React from 'react';
import { motion } from 'framer-motion';
import LottiePlayer from './LottiePlayer';

/**
 * Sparkle effect using the new 'Image Preload Gradient.json'.
 * Positioned mid-left, below user bubble.
 * BIGGER to cover the response area.
 */
export default function SparkleEffect({ phase = 'sparkling' }) {
  const isFading = phase === 'responding';

  return (
    <motion.div
      data-testid="sparkle-effect"
      style={{
        position: 'absolute',
        left: 10,
        top: 136,
        width: '90%',
        maxWidth: 360,
        height: 260,
        zIndex: 24,
        pointerEvents: 'none',
        display: 'flex', justifyContent: 'flex-start', alignItems: 'center'
      }}
      initial={{ opacity: 0, scale: 0.88, y: 12 }}
      animate={{ opacity: isFading ? 0 : 0.96, scale: isFading ? 0.96 : 1, y: isFading ? -6 : 0 }}
      exit={{ opacity: 0, scale: 0.92, y: -4 }}
      transition={{ duration: isFading ? 0.6 : 0.45, ease: 'easeOut' }}
    >
      <div style={{ width: '100%', height: '100%' }}>
        <LottiePlayer
          src="/animations/sparkle_new.json"
          loop
          autoplay
          speed={1}
          preserveAspectRatio="xMidYMid meet"
          style={{ width: '100%', height: '100%', opacity: 0.95 }}
          testId="lottie-sparkle"
        />
      </div>
    </motion.div>
  );
}
